import { render, staticRenderFns } from "./AutodeskForgeViewer.vue?vue&type=template&id=c5666f56&scoped=true&"
import script from "./AutodeskForgeViewer.vue?vue&type=script&lang=js&"
export * from "./AutodeskForgeViewer.vue?vue&type=script&lang=js&"
import style0 from "./AutodeskForgeViewer.vue?vue&type=style&index=0&id=c5666f56&scoped=true&lang=scss&"
import style1 from "./AutodeskForgeViewer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5666f56",
  null
  
)

export default component.exports